import { Controller } from "@hotwired/stimulus";

const maxFileSize = 100;

export default class extends Controller {
  static targets = ["file", "clearIcon", "removeField"];

  connect() {
    this.accept = this.fileTarget.accept
      ? new RegExp(this.fileTarget.accept)
      : /.*/;

    const currentValue = this.data.get("value");

    if (currentValue) {
      this.setImage(currentValue);
    }

    this.element.addEventListener("click", () => {
      this.fileTarget.click();
    });

    this.fileTarget.addEventListener("change", (e) => {
      this.handleFiles(e.target.files);
    });

    this.clearIconTarget.addEventListener("click", (e) => {
      e.stopPropagation();
      this.clearImage();
    });

    this.element.addEventListener("drop", (e) => {
      e.preventDefault();
      this.fileTarget.files = e.dataTransfer.files;
      this.handleFiles(e.dataTransfer.files);
    });

    this.element.addEventListener("dragover", (e) => {
      e.preventDefault();
    });
  }

  handleFiles(files) {
    const file = files[0];

    if (file.size / 1024 / 1024 > maxFileSize) {
      alert(`Max file size is ${maxFileSize}MB`);
      this.fileTarget.value = null;
      return;
    }

    if (!this.accept.test(file.type)) {
      alert("File format not supported");
      this.fileTarget.value = null;
      return;
    }

    this.setImage(URL.createObjectURL(file));
  }

  setImage(url) {
    this.element.classList.add("has-image");
    this.element.style.backgroundImage = `url('${url}')`;
    this.clearIconTarget.style.display = "";
    this.removeFieldTarget.value = 0;
  }

  clearImage() {
    this.element.style.backgroundImage = "";
    this.element.classList.remove("has-image");
    this.fileTarget.value = null;
    this.clearIconTarget.style.display = "none";
    this.removeFieldTarget.value = 1;
  }
}
